export const buildQueryString = (params: {
  [key: string]: string | number | boolean | string[] | null;
}): string => {
  return Object.entries(params)
    .filter(
      ([, value]) => value !== "" && value !== undefined && value !== null,
    )
    .flatMap(([key, value]) =>
      Array.isArray(value)
        ? value.map(
            (v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`,
          )
        : [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`],
    )
    .join(",");
};

export const buildQueryString2 = (action: {
  [key: string]: string | number | boolean | undefined | null;
}) =>
  Object.entries(action)
    .filter(([, val]) => val !== "" && val !== undefined && val !== null)
    .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(val))}`)
    .join("&");
